// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6svkQ","colMin":"styles_colMin__2J5nN"};